import React from 'react';
import { connect } from 'react-redux';
import { withAdminLayout } from '../../common/admin-layout';
import { ADMIN_PAGES } from '../../assets/constants/global';
import { adminActions } from './admin-reducer';
import { BaseAdmin } from './base';
import { PROP_KEYS, ACTION_LOAD_TYPES, TEMPLATE_TYPES, ACTION_IMPORT_TYPES } from './admin-constants';

class AdminAdditionalOptions extends React.Component {
    componentDidMount() {
        const { loadData } = this.props;

        loadData();
    }

    render() {
        const { 
            additionalOptions, additionalOptionsErrorMsg, handleDataPageChange, handleDataPageSizeChange,
            additionalOptionsPagination, isLoadedAdditionalOptions, importData, exportData,
            setImportedData, downloadTemplate, cleanDataErrorMsg, handleSort, additionalOptionColumnTypes
        } = this.props;
        const baseProps = {
            data: additionalOptions,
            isLoaded: isLoadedAdditionalOptions,
            errorMsg: additionalOptionsErrorMsg,
            handleImportData: importData,
            handleExportData: exportData,
            setImportedData: setImportedData,
            downloadTemplate: downloadTemplate,
            pagination: additionalOptionsPagination,
            handlePageChange: handleDataPageChange,
            handlePageSizeChange: handleDataPageSizeChange,
            cleanErrorMsg: cleanDataErrorMsg,
            sortData: handleSort,
            columnTypes: additionalOptionColumnTypes
        };

        return (
            <BaseAdmin {...baseProps} />
        );
    }
}

const mapStateToProps = (state) => {
    const { admin } = state;
    const { additionalOptions, additionalOptionsPagination, isLoadedAdditionalOptions, additionalOptionsErrorMsg, additionalOptionColumnTypes } = admin;

    return {
        additionalOptions, isLoadedAdditionalOptions, additionalOptionsPagination, additionalOptionsErrorMsg, additionalOptionColumnTypes
    };
}

const { action, isLoadedKey, paginationKey, dataKey, importAction, importedKey, errorMsgKey, fileKey, columnTypesKey } = {
    action: ACTION_LOAD_TYPES.additionalOptionType,
    isLoadedKey: PROP_KEYS.isLoadedAdditionalOptions,
    paginationKey: PROP_KEYS.additionalOptionsPagination,
    dataKey: PROP_KEYS.additionalOptions,
    importAction: ACTION_IMPORT_TYPES.additionalOptionType,
    importedKey: PROP_KEYS.importedAdditionalOptions,
    errorMsgKey: PROP_KEYS.additionalOptionsErrorMsg,
    fileKey: TEMPLATE_TYPES.AdditionalOption,
    columnTypesKey: PROP_KEYS.additionalOptionColumnTypes
}

const mapDispatchToProps = {
    loadData: () => adminActions.load({ 
        action, isLoadedKey, paginationKey, dataKey, fileKey, columnTypesKey
    }),
    importData: () => adminActions.importData({
        importAction, action, isLoadedKey, importedKey, errorMsgKey, paginationKey, dataKey
    }),
    exportData: () => adminActions.exportData({ 
        action, isLoadedKey, fileKey
    }),
    setImportedData: (file) => adminActions.setValue(importedKey, file),
    cleanDataErrorMsg: () => adminActions.setValue(errorMsgKey, []),
    downloadTemplate: () => adminActions.downloadTemplate({
        isLoadedKey, fileKey
    }),
    handleDataPageChange: (page, pageSize) => adminActions.handlePaginationChange(page, pageSize, { 
        action, isLoadedKey, paginationKey, dataKey, fileKey, columnTypesKey
    }),
    handleDataPageSizeChange: (_page, pageSize) => adminActions.handlePaginationChange(1, pageSize, { 
        action, isLoadedKey, paginationKey, dataKey, fileKey, columnTypesKey
    }),
    handleSort: (_pagination, _filters, sorter) => adminActions.handleSort(1, sorter, { 
        action, isLoadedKey, paginationKey, dataKey, fileKey, columnTypesKey
    })
}

const connectedAdminAdditionalOptions = connect(mapStateToProps, mapDispatchToProps)(withAdminLayout(AdminAdditionalOptions, ADMIN_PAGES.AdminAdditionalOptions));
export { connectedAdminAdditionalOptions as AdminAdditionalOptions };